import { ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

interface AnimatePresenceWrapperProps {
  children: ReactNode;
  mode?: 'sync' | 'wait' | 'popLayout';
}

const AnimatePresenceWrapper: React.FC<AnimatePresenceWrapperProps> = ({ children, mode = 'sync' }) => {
  if (!children) return null;

  const content = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return <motion.div>{child}</motion.div>;
    }
    return child;
  });

  const AnimatePresenceComponent = AnimatePresence as any;
  return (
    <AnimatePresenceComponent mode={mode}>
      {content}
    </AnimatePresenceComponent>
  );
};

export default AnimatePresenceWrapper;